/**
 * Форматирует строку как номер карты (16 цифр) или номер телефона (11 цифр).
 * @param input Исходное значение — номер карты или телефона
 * @returns Отформатированная строка
 */
export function formatCardOrPhone(input: string): string {
  const digits = input.replace(/\D/g, '')

  // Формат: 0000 0000 0000 0000
  if (digits.length === 16) {
    return digits.replace(/(\d{4})(?=\d)/g, '$1 ').trim()
  }

  // Формат: +7 940 716-79-96
  if (digits.length === 11 && /^[78]/.test(digits)) {
    return digits.replace(/^(\d)(\d{3})(\d{3})(\d{2})(\d{2})$/, '+7 $2 $3-$4-$5')
  }

  return input
}
